import {Consts} from "../pages/consts";
import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import useMmcService from "../../services/MmcService";
import InitContext from "../pages/InitContext";
import Diseases from "../patientInit/Diseases";

const PatientDisease = ({patient, updatePatient, showDialog, onCloseDialog}) => {
  const { t } = useTranslation();
  const [patientDiseases, setPatientDiseases] = useState([]);
  const [patientsDiseasesInDb, setPatientsDiseasesInDb] = useState([]);
  const context = useContext(InitContext);
  const {clearError, getDbDiseases, saveDbDisease} = useMmcService();

  useEffect(() => {
    clearError();

    if (patient?.id && context?.token && context?.token !== "") {
      getDbDiseases(context?.token, patient?.id).then((data) =>
        setPatientsDiseasesInDb(data?.diseases),
      );
    }
  }, []);

  const saveDiseases = () => {
    clearError();

    patientDiseases?.forEach((disease) => {
      if (context?.token && context?.token !== "") {
        saveDbDisease(context?.token, disease, patient?.id).then((result) => {
          disease = { ...disease, id: result?.id };
          setPatientsDiseasesInDb([...patientsDiseasesInDb, disease]);
          setPatientDiseases([]);
          updatePatient(disease?.begin);
        });
      }
    });

    onCloseDialog();
  };

  let diseasesToShow = []

  if (patientsDiseasesInDb?.length > 0) {
    diseasesToShow = [...patientsDiseasesInDb];
  }

  if (patientDiseases?.length > 0) {
    diseasesToShow = [...diseasesToShow, ...patientDiseases];
  }

  return(
    <div className="w3-modal" style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}>
      <div className={`w3-modal-content w3-card-4 w3-animate-zoom w3-theme-l3 ${context?.role === Consts.HCP_PRESCRIBER 
        ? "dialog-wide" : "dialog-small"}`}>
        <Diseases patientDiseases={patientDiseases} onSetPatientDiseases={setPatientDiseases}
                  diseasesToShow={diseasesToShow} setPatientsDiseasesInDb={setPatientsDiseasesInDb}/>
        <div>
          <button
            onClick={onCloseDialog}
            className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin"
            type="text"
          >
            {t("close")}
          </button>
          {context?.role === Consts.HCP_PRESCRIBER &&
            <button
              onClick={saveDiseases}
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin"
              type="text"
              disabled={!patientDiseases?.length}
            >
              {t("save_diseases")}
            </button>
          }
        </div>
      </div>
    </div>
  );
}

export default PatientDisease;